import "../../js/helper/Helper.String.js";

const HelperStringObject: typeof HelperString = window.Helper.String;

export {HelperStringObject as HelperString};